<template>
<div>
   <Breadcrumb> 
            <span><router-link :to="{ path:'/'}">Početna</router-link></span>
            <span class="separetor">/</span>
            <span class="font-weight-bolder"><router-link :to="{ name:'kontakt'}">Kontakt</router-link></span>
     </Breadcrumb>
    <section class="has-sidebar u-padding-tb-40">
            <div class="container">
                <div class="row" data-sticky_parent>
                    <div class="col-lg-12 content-wrapper">
                        <div data-sticky_column>
                            <div class="contact-form">
                                <div class="form-title">
                                    <h4>Kontakt</h4>
                                </div>
                                <div class="form-body">
                                    <div class="m-post-content">
                                      <div class=" entry-content">
                                        <div class="row u-margin-b-30">
                                        <div class="col-sm-6">
                                            <div class="card">
                                            <div class="card-body">
                                                <h5 class="card-title"><i class="fa fa-map-marker"></i> Adresa</h5>
                                                <p class="card-text">{{ contactInfo.address }}</p>
                                            </div>
                                            </div>
                                        </div>
                                      
                                        <div class="col-sm-6">
                                            <div class="card">
                                            <div class="card-body">
                                                <h5 class="card-title"><i class="fa fa-envelope-o"></i> E-mail</h5>
                                                <p class="card-text"><a v-bind:href="`mailto:${contactInfo.email}`">{{ contactInfo.email }}</a></p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="map">
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1438.687745325619!2d18.400434258295757!3d43.848045394778744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4758c8e18c6b196d%3A0xd6806f7e5dadb39c!2sRadni%C4%8Dka%2C%20Sarajevo%2071000!5e0!3m2!1sen!2sba!4v1601376478105!5m2!1sen!2sba" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                        </div>
                                            <div class="row u-margin-t-30">
                                                <div class="col-sm-12">
                                              <div class="widget widget--border-box social-grid">
                            <div class="widget__title">
                                <h4>Pratite nas na društvenim mrežama</h4>
                            </div>
                            <div class="list-wrap">
                                <ul class="media-lists social--color">
                                    <li>
                                        <a class="social__facebook" v-bind:href="about.facebookPage" target="_blank">
                                            <div class="media__inner">
                                                <i class="fa fa-facebook"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="social__twitter media__inner" v-bind:href="about.twitterPage" target="_blank">
                                            <div class="media__inner">
                                                <i class="fa fa-twitter"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="social__instagram media__inner" v-bind:href="about.instagramPage" target="_blank">
                                            <div class="media__inner">
                                                <i class="fa fa-instagram"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="social__youtube media__inner" v-bind:href="about.youtubeChannel" target="_blank">
                                            <div class="media__inner">
                                                <i class="fa fa-youtube"></i>
                                            </div>
                                        </a>
                                    </li>  
                                </ul>
                            </div>
                        </div>
                        </div>
                              </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>     
 </template>

<script>
    import { AboutService } from '../common/api.service'
    import Breadcrumb from '../components/Breadcrumb'

    export default {
        name: "Contact",
        components: { Breadcrumb },
        metaInfo: {
            title: 'Kontakt',        
        },
        data() {
            return {
                contactInfo: {},
                about: {}
            }
        },
        mounted() {
            window.scrollTo(0, 0);
        },
         created() {
            this.fetchData();      
        },
        methods: {
            fetchData: function() {
                AboutService.getContactInfo().then(res => this.contactInfo = res.data);
                AboutService.getAboutInfo().then(res => this.about = res.data);
            }
        }
    }
</script>

<style scoped>
     .widget--border-box.social-grid .media-lists li {
        flex: 0 0 25.000%;
        -webkit-flex: 0 0 25.000%;
        -ms-flex: 0 0 25.000%;
    }

    .map {
        overflow:hidden;
        padding-bottom:56.25%;
        position:relative;
        height:0;
    }
    
    .map iframe{
        left:0;
        top:0;
        height:100%;
        width:100%;
        position:absolute;
    }
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue